export default "__VITE_ASSET__D3CCz43G__"